import { CommonModule } from '@angular/common';
import {
  Component, computed, input, model, output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { provideNgxMask, NgxMaskDirective } from 'ngx-mask';

import { FieldState, toStringValue } from '../../../models/field.model';
import { InlineSvgComponent } from '../../inline-svg/inline-svg.component';

@Component({
  selector: 'ui-text-field',
  imports: [ CommonModule, FormsModule, InlineSvgComponent, NgxMaskDirective ],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.scss',
  providers: [
    provideNgxMask(),
  ],
})
export class TextFieldComponent {
  /** Defines the style of the text field. */
  fieldState = FieldState;
  /** A unique name identifier for the text component.
   *  The name is a string generated with a random hexadecimal number.
  */
  name = input<string>(`ui-text-field-${(Math.round((Math.random() * 100000000)).toString(16))}`);
  /** Output bind value. */
  value = model<string | undefined>('');
  /** Defines the current style of the text field. */
  state = input<FieldState>(FieldState.Default);
  /** Defines the placeholder of the text field. */
  placeholder = input<string>('');
  /** Alert text message to be displayed based on the value. */
  alert = input<string>();
  /** Mask text to be displayed as a reference. */
  mask = input<string>('');
  /** Prefix rendered before the value (e.g. a currency symbol). Requires a mask. */
  prefix = input<string>('');
  /** Thousand separator used by numeric (separator) masks. */
  thousandSeparator = input<string>(' ');
  /** Decimal marker used by numeric (separator) masks. */
  decimalMarker = input<'.' | ',' | ['.', ',']>('.');
  /** Allows a leading minus sign on numeric (separator) masks. */
  allowNegativeNumbers = input<boolean>(false);
  /** Defines the icon of the text field. */
  icon = input<string>('');
  /** Defines the icon position of the text field. */
  iconPosition = input<string>('');
  /** Defines if the text field is readonly. */
  disabled = input<boolean>(false);
  /** Emits when the input loses focus. */
  blurred = output<string | undefined>();

  /** Computed property that returns the alert icon
   * that should be displayed based on the FieldState.
  */
  alertIcon = computed(() => {
    switch (this.state()) {
      case FieldState.Success:
      case FieldState.Info:
        return 'success';
      case FieldState.Invalid:
        return 'error';
      default:
        return '';
    }
  });

  toStringValue = toStringValue;
}
